import React from 'react';
import BannerSectionStyle3 from '../Section/BannerSection/BannerSectionStyle3';
import AppointmentWithContactInfoSection from '../Section/AppointmentWithContactInfoSection';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';

export default function Appointments() {
  pageTitle('Appointments');
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/appointments/banner_bg.svg"
        imgUrl="/illustrations/Noohra-Services Hero8.webp"
        title="Don’t Let Your Mental Health Take a Backseat!"
        subTitle="Fill out the appointment form below to schedule a consultation with one of our healthcare professionals."
      />
      <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <AppointmentWithContactInfoSection />
      </Section>

      <Section 
      // topMd={200}
        // topLg={150}
        // topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110} className="cs_footer_margin_0">
        {/* <BannerSectionStyle3
          bgUrl="/images/appointments/banner_bg.svg"
          imgUrl="/illustrations/Noohra-Services Hero6.webp"
          title="Don’t Let Your Mental Health Take a Backseat!"
          subTitle="Fill out the intake form below to help us understand your needs, background, and goals for therapy so we can provide you with the best possible care. "
          btnText={'Client Intake Form'}
          btnUrl={'https://forms.clickup.com/f/8cjw8vy-292/RZO9EP8NTCK0E6TYYU'}
          btnText2={'Organization Intake Form'}
          btnUrl2={'https://forms.clickup.com/9012388734/f/8cjw8vy-312/PJ2Z7FGI1AXEVDX0U1'}
        /> */}
      </Section>

          </>
  );
}
